export const EVENTS_STAGE_FILTER_NONE = '__events_stage_filter_none__';

export function resolveSelectedStageStatuses(
  stageFilters: Iterable<string>,
  stageLabelToStatuses: Map<string, string[]>,
  defaultStageStatuses: string[],
): Set<string> {
  const filters = Array.from(stageFilters);
  if (filters.includes(EVENTS_STAGE_FILTER_NONE)) return new Set();

  const statuses = new Set<string>();
  for (const label of filters) {
    for (const status of stageLabelToStatuses.get(label) ?? []) {
      statuses.add(status);
    }
  }
  if (statuses.size === 0 && defaultStageStatuses.length > 0) {
    for (const status of defaultStageStatuses) statuses.add(status);
  }
  return statuses;
}

export function stageStatusesToFilterValues(
  statuses: string[],
  statusToStageLabel: Map<string, string>,
): string[] {
  if (statuses.length === 0) return [EVENTS_STAGE_FILTER_NONE];

  const labels: string[] = [];
  for (const status of statuses) {
    const label = statusToStageLabel.get(status);
    if (label && !labels.includes(label)) labels.push(label);
  }
  return labels.length > 0 ? labels : [EVENTS_STAGE_FILTER_NONE];
}
